import {_} from 'vue-underscore';

export default {
    data() {
        return {
            departments: null,
            diseases: null,
            digests: null,
            symptoms: null,
            sorts: null,
            categories: null,
            selectedDiseases: null,
            selectedSymptoms: null
        };
    },
    newinit(data){
        this.departments = data.departments;
        this.diseases = data.diseases;
        this.digests = data.digests;
        this.symptoms = data.symptoms;
        this.categories = data.categories;

        this.selectedDiseases = new Array();
        this.selectedSymptoms = new Array();
    },
    copyArray(org, func) {
        var i = org.length, cpy = new Array(i);
        if (func != null) {
            while (i--) cpy[i] = func(org[i]);
        } else {
            while (i--) cpy[i] = org[i];
        }
        return cpy;
    },
    addItem(arr, item) {
        if (_.indexOf(arr, item) > -1) return false;
        arr.push(item);
        return true;
    },
    removeItem(arr, item) {
        var pos = _.indexOf(arr, item);
        if (pos == -1) return false;
        arr.splice(pos, 1);
        return true;
    },
    checkCapInits(value, keyword) {
        return value.indexOf(keyword) > -1;
    },
    getDepartments() {
        var arr = this.copyArray(this.departments, function(item) {
                return {
                    'id': item[0]+1,
                    'name': item[1]
                };
        });
        arr.unshift({'id': 0, 'name': '全科'});
        return arr;
    },
    diseaseAsObject(disease) {
        return {
            'id': disease[0],
            'label': disease[1],
            'xpy': disease[2]
        }
    },
    getDiseasesOfDepartment(department, capinits) {
        var me = this;
        if (_.isNumber(department)) {
            if (0 == department){
                return me.getDiseases(capinits);
            }
            department = this.departments[department-1];
        }
        var indices = department[2], i = indices.length, cpy = new Array(i), diseases = this.diseases;
        while (i--) cpy[i] = me.diseaseAsObject(diseases[indices[i]]);
        if (capinits) {
            return _.filter(cpy, function(d) {  return me.checkCapInits(d.xpy, capinits); });
        }
        return cpy;
    },
    getDiseases(department, capinits) {
        if (department != "") {
            return this.getDiseasesOfDepartment(department, capinits);
        }
        
        var me=this, i=me.diseases.length, cpy = new Array(i);
        
        while (i--) cpy[i] = me.diseaseAsObject(me.diseases[i]);
        if (capinits) {
            return _.filter(cpy, function(d) { return me.checkCapInits(d.xpy, capinits); })
        }
        return cpy;
    },
    getCategories() {
        return this.copyArray(this.categories, function(item){
            return {
                'id': item[0],
                'name': item[1],
            };
        });
    },
    symptomAsObject(symptom) {
        return {
            'id': symptom[0],
            'label': symptom[1]
        }
    },
    getPrimariesOfCategory(category, capinits) {
        if (_.isNumber(category)) category = this.categories[category];
        var me = this, symptoms = me.symptoms, primaryFilter;
        if (me.selectedDiseases.length > 0) {
            primaryFilter = _.union.apply(null, _.map(me.selectedDiseases,
                function(d) {return me.diseases[d][4]}));
        } else {
            var result = this.copyArray(category[2], function(i) {
                return me.symptomAsObject(symptoms[i]);
            });
            return result;
        }
        var cpy = this.copyArray(category[2], function(i) {
            var s = me.symptomAsObject(symptoms[i]);
            if (_.indexOf(primaryFilter, i) < 0) s.disabled = true;
            return s;
        });
        if (capinits) {
            return _.filter(cpy, function(s) { return me.checkCapInits(s[3], capinits); })
        }
        return cpy;
    },
    getPrimaries(category, capinits) {
        if (category != null) {
            return this.getPrimariesOfCategory(category, capinits);
        }
        return null;
    },
    selectDisease(disease) {
        if (!_.isNumber(disease)) disease = disease[0];
        return this.addItem(this.selectedDiseases, disease);
    },
    selectSymptom(symptom) {
        if (!_.isNumber(symptom)) symptom = symptom[0];
        return this.addItem(this.selectedSymptoms, symptom);
    },
    unselectDisease(disease) {
        if (!_.isNumber(disease)) disease = disease[0];
        return this.removeItem(this.selectedDiseases, disease);
    },
    unselectSymptom(symptom) {
        if (!_.isNumber(symptom)) symptom = symptom[0];
        return this.removeItem(this.selectedSymptoms, symptom);
    },
    clearSelectedDiseases() {
        this.selectedDiseases = new Array();
    },
    clearSelectedSymptoms() {
        this.selectedSymptoms = new Array();
    },
    clearSelection: function() {
        this.clearSelectedDiseases();
        this.clearSelectedSymptoms();
    },
    getRelatedSymptoms() {
        var me=this;
        var selectedSymptomCount = me.selectedSymptoms.length;
        if (0 == selectedSymptomCount) {
            var candidate_indices = _.union.apply(null, _.map(me.selectedDiseases,
                function(d) { return me.diseases[d][4]; }))
            var sorted_indices = _.sortBy(candidate_indices,
                function(i) { return -me.symptoms[i]['weight']; });
            return this.copyArray(sorted_indices, function(i) {
                return me.symptomAsObject(me.symptoms[i]);
            });
        }

        var digestFilter;
        if (me.selectedDiseases.length > 0) {
            digestFilter = _.union.apply(null, _.map(me.selectedDiseases,
                function(d) { return me.diseases[d][3]; }))
        }
        var digestCount = me.digests.length, counter = new Object();
        var relatedDigests, intersectSymptomCount, digestSymptoms, diffSymptoms, j, k, d;
        var i = selectedSymptomCount;
        while (i--) {
            if (digestFilter != null) {
                relatedDigests = _.intersection(me.symptoms[me.selectedSymptoms[i]][4], digestFilter);
            } else {
                relatedDigests = me.symptoms[me.selectedSymptoms[i]][4];
            }
            j = relatedDigests.length;
            while (j--) {
                digestSymptoms = me.digests[relatedDigests[j]];
                diffSymptoms = _.difference(digestSymptoms, me.selectedSymptoms);
                k = diffSymptoms.length;
                intersectSymptomCount = digestSymptoms.length - k;
                while (k--) {
                    var symptom = diffSymptoms[k];
                    if (!Object.prototype.hasOwnProperty.call(counter, symptom)) {
                        counter[symptom] = { 'maxCnt': intersectSymptomCount, 'digests': new Array() };
                    }
                    d = counter[symptom];
                    if (intersectSymptomCount > d['maxCnt']) {
                        d['maxCnt'] = intersectSymptomCount;
                        d['digests'] = new Array();
                    } else if (intersectSymptomCount == d['maxCnt']) {
                        this.addItem(d['digests'], symptom);
                    }
                }
            }
        }
        var candidates = _.mapObject(counter, function(val, key) {
            return { 'symptom': key,
                'weight': -(val['maxCnt'] * digestCount + val['digests'].length + me.symptoms[key][2])};
        });
        var sorted_candidates = _.sortBy(candidates, function(t) { return -t['weight']; });
        i = sorted_candidates.length;
        var result = new Array(i);
        while (i --) { result[i] = me.symptomAsObject(me.symptoms[parseInt(sorted_candidates[i].symptom)]); }
        return result;
    }
}